<template>
    <ModalOverlay @click="$emit('close')">
        <ModalContent @click.stop>
            <ModalHeader>
                <ModalTitle>파일 미리보기</ModalTitle>
                <ModalCloseButton @click="$emit('close')">✕</ModalCloseButton>
            </ModalHeader>
            <ModalBody>
                <FileDetailContainer>
                    <FilePreview>
                        <!-- 이미지 파일 미리보기 -->
                        <ImageContainer v-if="isImage">
                            <PreviewImage :src="filePreviewUrl" :alt="file.original_name" @error="handleImageError"
                                @load="handleImageLoad" />
                            <ImageError v-if="imageError">
                                이미지를 불러올 수 없습니다.
                            </ImageError>
                            <ImageLoading v-if="imageLoading">
                                이미지 로딩 중...
                            </ImageLoading>
                        </ImageContainer>

                        <!-- PDF 파일 미리보기 -->
                        <PDFContainer v-else-if="isPDF">
                            <PDFViewer :src="filePreviewUrl" />
                            <PDFError v-if="pdfError">
                                PDF를 불러올 수 없습니다.
                            </PDFError>
                            <PDFLoading v-if="pdfLoading">
                                PDF 로딩 중...
                            </PDFLoading>
                        </PDFContainer>

                        <!-- 기타 파일 정보 표시 -->
                        <FileInfo v-else>
                            <FileIcon>{{ fileIcon }}</FileIcon>
                            <FileName>{{ file.original_name }}</FileName>
                            <FileType>{{ fileType }}</FileType>
                            <FileSize>{{ formatFileSize(file.file_size) }}</FileSize>
                            <FileUploadDate>{{ formatDate(file.upload_date) }}</FileUploadDate>
                        </FileInfo>
                    </FilePreview>
                </FileDetailContainer>
            </ModalBody>
            <ModalFooter>
                <ModalButton @click="$emit('close')" class="secondary">닫기</ModalButton>
            </ModalFooter>
        </ModalContent>
    </ModalOverlay>
</template>

<script>
import * as FileDetailModalCss from '@/assets/styles/claim/modal/FileDetailModalCss.js';

export default {
    name: 'FileDetailModal',

    components: {
        ...FileDetailModalCss
    },

    props: {
        file: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            imageError: false,
            imageLoading: true,
            pdfError: false,
            pdfLoading: true
        };
    },

    computed: {
        isImage() {
            const extension = this.file.original_name.split('.').pop()?.toLowerCase();
            return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension);
        },

        isPDF() {
            const extension = this.file.original_name.split('.').pop()?.toLowerCase();
            return extension === 'pdf';
        },

        filePreviewUrl() {
            if (this.file.key) {
                return `https://hanqmedi.s3.ap-northeast-2.amazonaws.com/${this.file.key}`;
            } else if (this.file.id) {
                return `${this.$apiUrls?.hanqmedi || ''}/getFilePreview/${this.file.id}`;
            }
            return '';
        },

        fileIcon() {
            const extension = this.file.original_name.split('.').pop()?.toLowerCase();
            const iconMap = {
                'pdf': '📄',
                'doc': '📝',
                'docx': '📝',
                'xls': '📊',
                'xlsx': '📊',
                'txt': '📄',
                'zip': '📦',
                'rar': '📦',
                'hwp': '📋',
                'ppt': '📊',
                'pptx': '📊'
            };
            return iconMap[extension] || '📁';
        },

        fileType() {
            const extension = this.file.original_name.split('.').pop()?.toLowerCase();
            const typeMap = {
                'pdf': 'PDF 문서',
                'doc': 'Word 문서',
                'docx': 'Word 문서',
                'xls': 'Excel 스프레드시트',
                'xlsx': 'Excel 스프레드시트',
                'txt': '텍스트 파일',
                'pptx': 'PowerPoint 프레젠테이션'
            };
            return typeMap[extension] || '알 수 없는 파일';
        }
    },

    methods: {
        handleImageError() {
            this.imageError = true;
            this.imageLoading = false;
        },

        handleImageLoad() {
            this.imageLoading = false;
            this.imageError = false;
        },

        handlePDFError() {
            this.pdfError = true;
            this.pdfLoading = false;
        },

        handlePDFLoad() {
            this.pdfLoading = false;
            this.pdfError = false;
        },

        formatFileSize(bytes) {
            if (!bytes || bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        },

        formatDate(dateString) {
            if (!dateString) return '-';
            const date = new Date(dateString);
            return date.toLocaleDateString('ko-KR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        }
    },

    mounted() {
        if (this.isImage) {
            this.imageLoading = true;
            this.imageError = false;
        } else if (this.isPDF) {
            this.pdfLoading = true;
            this.pdfError = false;
        }
    }
};
</script>